// Vendors
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import classnames from 'classnames';

const SearchBox = ({
  currentRefinement,
  refine,
  className,
  id,
  name,
  label = ''
}) => (
  <form
    noValidate
    action=""
    role="search"
    onSubmit={(event) => event.preventDefault()}
  >
    <div className={classnames('form__field', className)}>
      {label && (
        <label className="form__label u--visible-sr" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="form__input-group form__input-group--lg">
        <input
          id={id || name}
          name={name}
          type="text"
          className="form__input"
          placeholder={label}
          value={currentRefinement}
          onChange={(event) => refine(event.currentTarget.value)}
        />
        <button className="btn btn--blue">
          <span className="btn__content">
            <span className="btn__text">Search</span>
          </span>
        </button>
      </div>
    </div>
  </form>
);

export default connectSearchBox(SearchBox);
